
/**
 * Note after logout some of the unSet... method is called from Explorer component within beforeDestory
 * calling code can be impoved
 */ 

import $ from "jquery"
//import exportDamcomponentsToPlugins from '../../../export-components-for-plugins.js';

export default {
    registerOverflowMenu(state, payload) {
        if (typeof(payload) == undefined || !Object.keys(payload).includes("id") || payload.id.trim().length <= 0) {
            return
        }
        let menu = state.overFlowMenu.filter((oMenu) => oMenu.id == payload.id)
        if (menu.length == 0) {
            state.overFlowMenu.push(payload)
        }
    },
    unSetOverflowMenu(state) {
        state.overFlowMenu = []
    },
    registerQuickAccessPanel(state, payload) {
        if (typeof(payload) == undefined || !Object.keys(payload).includes("id") || payload.id.trim().length <= 0) {
            return
        }
        let panel = state.quickAccessPanel.filter((menu) => menu.id == payload.id && menu.label == payload.label);
        if (panel.length == 0) {
            state.quickAccessPanel.push(payload)
        }
    },
    sortQuickAccessPanelArr(state){
        state.quickAccesPanelSortedArr = state.quickAccessPanel.sort(function(a, b){return a.position_priority - b.position_priority})
    },
    unSetQuickAccessPanel(state) {
        state.quickAccessPanel = []
    },
    removeQuickAccessPanelEntry(state, payload){
        state.quickAccessPanel = state.quickAccessPanel.filter(op=>op.id != payload._id)
    },
    registerDashboardWidgets(state, payload){
        if (typeof(payload) == undefined || !Object.keys(payload).includes("widgetName") || payload.widgetName.trim().length <= 0) {
            return
        }
        let panel = state.dashboardWidgets.filter((menu) => menu.widgetName == payload.widgetName);
        if (panel.length == 0) {
            state.dashboardWidgets.push(payload);
        }
    },
    unsetDashboardWidgets(state){
        state.dashboardWidgets = []
    },

    registerSettingsSidemenu(state, payload) {
        if (typeof(payload) == undefined || !Object.keys(payload).includes("id") || payload.id.trim().length <= 0) {
            return
        }
        let panel = state.settingsSideMenu.filter((menu) => menu.id == payload.id)
        if (panel.length == 0) {
            state.settingsSideMenu.push(payload)
        }
    },
    unSetSettingsSidemenu(state) {
        let tempSettingsSidemenu = [];
        for(let i = 0; i < state.settingsSideMenu.length; i++){
             let plugin = state.settingsSideMenu[i];
            if(plugin && Object.prototype.hasOwnProperty.call(plugin,'externalPlugin') && plugin.externalPlugin){
                tempSettingsSidemenu.push(plugin);
            }
        }
        // state.settingsSideMenu = []
        state.settingsSideMenu = tempSettingsSidemenu;
    },

    registerFloatingMenu(state, payload) {
        if (typeof(payload) == undefined || !Object.keys(payload).includes("id") || payload.id.trim().length <= 0) {
            return
        }
        let panel = state.floatingMenu.filter((menu) => menu.id == payload.id)
        if (panel.length == 0) {
            state.floatingMenu.push(payload)
        }
    },
    unSetFloatingMenu(state) {
        state.floatingMenu = []
    },

    registerBinContextMenu(state, payload) {
        if (typeof(payload) == undefined || !Object.keys(payload).includes("id") || payload.id.trim().length <= 0) {
            return
        }
        let panel = state.binsContextMenu.filter((menu) => menu.id == payload.id)
        if (panel.length == 0) {
            state.binsContextMenu.push(payload)
        }
    },
    removeBinContextMenu(state, payload){
        state.binsContextMenu = state.binsContextMenu.filter((menu) => menu.id != payload.id)
    },
    unSetBinContextMenu(state) {
        state.binsContextMenu = []
    },
    registerBinsMoreActionsContextMenu(state, payload) {
        if (typeof(payload) == undefined || !Object.keys(payload).includes("id") || payload.id.trim().length <= 0) {
            return
        }
        let panel = state.binsMoreContextMenu.filter((menu) => menu.id == payload.id)
        if (panel.length == 0) {
            state.binsMoreContextMenu.push(payload)
        }
    },
    removeBinMoreContextMenu(state, payload){
        state.binsMoreContextMenu = state.binsMoreContextMenu.filter((menu) => menu.id != payload.id)
    },
    registerBinsShareActionsContextMenu(state, payload){
        if (typeof(payload) == undefined || !Object.keys(payload).includes("id") || payload.id.trim().length <= 0) {
            return
        }
        let panel = state.binsShareContextMenu.filter((menu) => menu.id == payload.id)
        if (panel.length == 0) {
            state.binsShareContextMenu.push(payload)
        }
    },
    registerCatalogIconActionsContextMenu(state, payload){
        if (typeof(payload) == undefined || !Object.keys(payload).includes("id") || payload.id.trim().length <= 0) {
            return
        }
        let panel = state.catalogIconContextMenu.filter((menu) => menu.id == payload.id)
        if (panel.length == 0) {
            state.catalogIconContextMenu.push(payload)
        }
    },
    registerExportActionsContextMenu(state, payload){
        if (typeof(payload) == undefined || !Object.keys(payload).includes("id") || payload.id.trim().length <= 0) {
            return
        }
        let panel = state.exportContextMenu.filter((menu) => menu.id == payload.id)
        if (panel.length == 0) {
            state.exportContextMenu.push(payload)
        }
    },
    registerAIToolActionsContextMenu(state, payload){
        if (typeof(payload) == undefined || !Object.keys(payload).includes("id") || payload.id.trim().length <= 0) {
            return
        }
        let panel = state.binsAIToolsContextMenu.filter((menu) => menu.id == payload.id)
        if (panel.length == 0) {
            state.binsAIToolsContextMenu.push(payload)
        }
    },
    registerOpenWithActionsContextMenu(state, payload){
        if (typeof(payload) == undefined || !Object.keys(payload).includes("id") || payload.id.trim().length <= 0) {
            return
        }
        let panel = state.binsOpenWithContextMenu.filter((menu) => menu.id == payload.id)
        if (panel.length == 0) {
            state.binsOpenWithContextMenu.push(payload)
        }
    },
    unsetAIToolActionsContextMenu(state){
        state.binsAIToolsContextMenu = []
    },
    unsetOpenWithActionsContextMenu(state){
        state.binsOpenWithContextMenu = []
    },
    unsetBinsNewActionsContextMenu(state, payload){
        if(!$.isEmptyObject(payload)){
            state.binsNewContextMenu = payload
        }else{
            state.binsNewContextMenu = [];
        }
    },
    unsetBinsImportActionContextMenu(state, payload){
        if(!$.isEmptyObject(payload)){
            state.binsImportContextMenu = payload
        }else{
            state.binsImportContextMenu = [];
        }
    },
    registerBinsNewActionsContextMenu(state, payload) {
        if (typeof(payload) == undefined || !Object.keys(payload).includes("id") || payload.id.trim().length <= 0) {
            return
        }
        let panel = state.binsNewContextMenu.filter((menu) => menu.id == payload.id)
        if (panel.length == 0) {
            state.binsNewContextMenu.push(payload)
        }
    },
    registerBinsImportActionsContextMenu(state, payload) {
        if (typeof(payload) == undefined || !Object.keys(payload).includes("id") || payload.id.trim().length <= 0) {
            return
        }
        let panel = state.binsImportContextMenu.filter((menu) => menu.id == payload.id)
        if (panel.length == 0) {
            state.binsImportContextMenu.push(payload)
        }
    },
    removeBinNewContextMenu(state, payload){
        state.binsNewContextMenu = state.binsNewContextMenu.filter((menu) => menu.id != payload.id)
    },
    removeBinImportContextMenu(state, payload){
        state.binsImportContextMenu = state.binsImportContextMenu.filter((menu) => menu.id != payload.id)
    },
    updateActionCallbacks(state, payload) {
        let onEvents = payload.onEvents
        let panel = state.binsContextMenu.filter((menu) => menu.id == payload.id)
        let newMenu = state.binsNewContextMenu.filter((menu) => menu.id == payload.id)
        let importMenu = state.binsImportContextMenu.filter((menu) => menu.id == payload.id)
        let moreMenu = state.binsMoreContextMenu.filter((menu) => menu.id == payload.id)
        let shareMenu = state.binsShareContextMenu.filter((menu) => menu.id == payload.id)
        let AIToolsMenu = state.binsAIToolsContextMenu.filter((menu) => menu.id == payload.id)
        let OpenWithMenu = state.binsOpenWithContextMenu.filter((menu) => menu.id == payload.id)
        let catalogIconMenu = state.catalogIconContextMenu.filter((menu) => menu.id == payload.id)
        let exportMenu = state.exportContextMenu.filter((menu) => menu.id == payload.id)

        if (panel.length == 0) {
            panel = state.binsContextMenu.filter((menu) => menu.action_name == payload.action_name)
        }
        if (newMenu.length == 0) {
            newMenu = state.binsNewContextMenu.filter((menu) => menu.action_name == payload.action_name)
        }
        if (importMenu.length == 0) {
            importMenu = state.binsImportContextMenu.filter((menu) => menu.action_name == payload.action_name)
        }
        if (moreMenu.length == 0) {
            moreMenu = state.binsMoreContextMenu.filter((menu) => menu.action_name == payload.action_name)
        }
        if (shareMenu.length == 0) {
            shareMenu = state.binsShareContextMenu.filter((menu) => menu.action_name == payload.action_name)
        }
        if(AIToolsMenu.length == 0){
            AIToolsMenu = state.binsAIToolsContextMenu.filter((menu) => menu.action_name == payload.action_name)
        }
        if(OpenWithMenu.length == 0){
            OpenWithMenu = state.binsOpenWithContextMenu.filter(menu=>menu.action_name == payload.action_name)
        }
        if(catalogIconMenu.length == 0){
            catalogIconMenu = state.catalogIconContextMenu.filter((menu) => menu.action_name == payload.action_name)
        }
        if(exportMenu.length == 0){
            exportMenu = state.exportContextMenu.filter((menu) => menu.action_name == payload.action_name)
        }

        if (panel.length != 0) {
            panel[0].onEvents = onEvents
        } else if (newMenu.length != 0) {
            newMenu[0].onEvents = onEvents
        } else if (importMenu.length != 0) {
            importMenu[0].onEvents = onEvents
        } 
        else if (moreMenu.length != 0) {
            moreMenu[0].onEvents = onEvents
        } else if (shareMenu.length != 0) {
            shareMenu[0].onEvents = onEvents
        } else if (AIToolsMenu.length != 0) {
            AIToolsMenu[0].onEvents = onEvents
        } else if (OpenWithMenu.length != 0){
            OpenWithMenu[0].onEvents = onEvents
        } else if (catalogIconMenu.length != 0){
            catalogIconMenu[0].onEvents = onEvents
        } else if (exportMenu.length != 0){
            exportMenu[0].onEvents = onEvents
        }

    },
    unSetBinsMoreActionsContextMenu(state) {
        state.binsMoreContextMenu = []
    },

    registerPreferenceSidemenu(state, payload) {
        if (typeof(payload) == undefined || !Object.keys(payload).includes("id") || payload.id.trim().length <= 0) {
            return
        }
        let panel = state.preferencesSidemenu.filter((menu) => menu.id == payload.id)
        if (panel.length == 0) {
            state.preferencesSidemenu.push(payload)
        }
    },
    unSetPreferencesSidemenu(state) {
        state.preferencesSidemenu = []
    },
    registerMyApps(state, payload) {
        if (typeof(payload) == undefined || !Object.keys(payload).includes("id") || payload.id.trim().length <= 0) {
            return
        }
        let panel = state.myApps.filter((menu) => menu.id == payload.id)
        if (panel.length == 0) {
            state.myApps.push(payload)
        }
    },
    updateMyApps(state, payload){
        if(!payload) return;
        if(payload && !Object.keys(payload).length) return;
        let info = state.myApps.find((oMenu) => oMenu.id == payload.id)
        if(info){
            Object.assign(info,payload.data);
        }
    },
    unSetMyApps(state) {
        state.myApps = []
    },

    registerReportsSidemenu(state, payload) {
        if (typeof(payload) == undefined || !Object.keys(payload).includes("id") || payload.id.trim().length <= 0) {
            return
        }
        let panel = state.reportsSideMenu.filter((menu) => menu.id == payload.id)
        if (panel.length == 0) {
            state.reportsSideMenu.push(payload)
        }
    },
    unSetReportsSideMenu(state) {
        state.reportsSideMenu = []
    },
    registerDamPlugin(state, payload) {
        let plugin = payload.plugin
        let jsFileUrl = payload.jsFileUrl
        let damInterface = payload.damInterface
        $.getScript(jsFileUrl, () => {
            console.log(`[registerDamPlugin][Registerting-->${plugin.id}]`);
            // let res = registerPlugin(damInterface, plugin) // eslint-disable-line no-undef
            let res = {};
            if(typeof registerPlugin != 'undefined'){
              try{
                res = registerPlugin(damInterface, plugin) // eslint-disable-line no-undef
              }catch(e){
                  console.error('Error [registerDamPlugin] :',e);
                  return;
              }
            }
            // state.pluginMapper[plugin.plugin_id] = res  //TO SUPPORT MULTIPLE QUICK ACCESS PANAL REGISTRATION FOR SINGLE PLUGIN
            state.pluginMapper[plugin.id] = res;
           // document.body["component"] = exportDamcomponentsToPlugins;
            console.log("[registerDamPlugin][Updated Registry--->]",state.pluginMapper)
            if(Object.prototype.hasOwnProperty.call(payload,"callbackFun") && typeof payload.callbackFun == 'function'){
                payload.callbackFun(res)
            }
        });
    },

    setLazyLoadPluginInfo(state, payload){
        state.lazyLoadPluginInfo = payload;
    },

    unsetLazyLoadPluginInfo(state){
        state.setLazyLoadPluginInfo = {};
    },

    loadExternalPluginConfigUI(state, payload) {
        let plugin_id = payload.id
        let tagId = payload.tagId
        console.log(`[loadExternalPluginConfigUI][loading plugin--->${plugin_id}]`)
        state.pluginMapper[plugin_id]["configUiCallback"]($, tagId)
    },

    loadExternalPluginChatUI(state, payload) {
        let plugin_id = payload.id
        let tagId = payload.tagId
        console.log(`[loadExternalPluginChatUI][loading plugin--->${plugin_id}]`)
        state.pluginMapper[plugin_id]["chatUiCallback"]($, tagId)
    },

    loadExternalPluginQuickAccessPanelUI(state, payload) {
        let plugin_id = payload.id
        let tagId = payload.tagId
        console.log(`[loadExternalPluginQuickAccessPanelUI][loading plugin--->${plugin_id}]`)
        state.pluginMapper[plugin_id]["quickAccessPanelUiCallback"]($, tagId)
    },
    loadExternalPluginWorkspaceUI(state, payload) {
        let plugin_id = payload.id
        let tagId = payload.tagId
        let callback = payload.callback || 'workspaceUiCallback';
        let loadInfo = {};
        if(payload.loadInfo){ 
            loadInfo = payload.loadInfo;
            state.lazyLoadPluginInfo = loadInfo;
        }
        console.log(`[loadExternalPluginWorkspaceUI][loading plugin--->${plugin_id}][callback -> ${payload.callback}]`)
        state.pluginMapper[plugin_id][callback]($, tagId,loadInfo,payload)
    },
    loadExternalPluginAsDialogUI(state, payload) {
        let plugin_id = payload.id
        let tagId = payload.tagId
        let callback = payload.callback || 'externalpluginDialogUiCallback';
        let loadInfo = {};
        if(payload.loadInfo){ 
            loadInfo = payload.loadInfo;
            state.lazyLoadPluginInfo = loadInfo;
        }
        console.log(`[externalpluginDialogUiCallback][loading plugin--->${plugin_id}][callback -> ${payload.callback}]`)
        state.pluginMapper[plugin_id][callback]($, tagId,loadInfo);
    },
    loadExternalPluginContextMenuDialogUI(state, payload) {
        let plugin_id = payload.id
        let tagId = payload.tagId
        console.log(`[loadExternalPluginContextMenuDialogUI][loading plugin--->${plugin_id}]`)
        state.pluginMapper[plugin_id]["contextMenuDialogUICallback"]($, tagId)
    },

    loadExternalPluginForSystemSettingsMenu(state, payload) {
        let plugin_id = payload.id
        let tagId = payload.tagId
        console.log("payloadpayload",payload)
        console.log(`[loadExternalPluginForSystemSettingsMenu][loading plugin--->${plugin_id}]`)
        state.pluginMapper[plugin_id]["systemSetttingsMenuUiCallback"]($, tagId)
    },

    loadExternalPluginForImportExportSettingsMenu(state, payload) {
        let plugin_id = payload.id
        let tagId = payload.tagId
        console.log(`[loadExternalPluginForImportExportSettingsMenu][loading plugin--->${plugin_id}]`)
        state.pluginMapper[plugin_id]["importExportMenuUiCallback"]($, tagId)
    },
    loadExternalPluginForShareMenu(state, payload) {
        let plugin_id = payload.id
        let tagId = payload.tagId
        console.log(`[loadExternalPluginForShareMenu][loading plugin--->${plugin_id}]`)
        state.pluginMapper[plugin_id]["shareMenuUiCallback"]($, tagId)
    },
    loadExternalPluginForShareWorkspaceMenu(state, payload) {
        let plugin_id = payload.id
        let tagId = payload.tagId
        console.log(`[loadExternalPluginForShareWorkspaceMenu][loading plugin--->${plugin_id}]`)
        state.pluginMapper[plugin_id]["workspaceUiCallback"]($, tagId)
    },
    loadExternalPluginOverflowMenuDialogUI(state, payload) {
        let plugin_id = payload.id
        let tagId = payload.tagId
        console.log(`[loadExternalPluginOverflowMenuDialogUI][loading plugin--->${plugin_id}]`)
        state.pluginMapper[plugin_id]["overflowMenuUiCallback"]($, tagId)
    },
    loadExternalPluginSettingsSideMenu(state, payload) {
        let plugin_id = payload.id
        let tagId = payload.tagId
        console.log(`[loadExternalPluginSettingsSideMenu][loading plugin--->${plugin_id}]`)
        state.pluginMapper[plugin_id]["settingsSideMenuUiCallback"]($, tagId)
    },
    loadExternalPluginPropertiesTopNavBar(state, payload) {
        let plugin_id = payload.id
        let tagId = payload.tagId
        console.log(`[loadExternalPluginPropertiesTopNavBar][loading plugin--->${plugin_id}]`)
        state.pluginMapper[plugin_id]["propertiesTopNavUiCallback"]($, tagId)
    },
    loadExternalPluginAsDialog(state, payload) {
        let plugin_id = payload.id
        let tagId = payload.tagId
        console.log(`[loadExternalPluginAsDialog][loading plugin--->${plugin_id}]`)
        state.pluginMapper[plugin_id]["dialogUiCallback"]($, tagId)
    },
    loadExternalPluginReportsSideMenu(state, payload) {
        let plugin_id = payload.id
        let tagId = payload.tagId
        console.log(`[loadExternalPluginReportsSideMenu][loading plugin--->${plugin_id}]`)
        state.pluginMapper[plugin_id]["reportsSideMenuUiCallback"]($, tagId)
    },
/*     loadExternalPluginWorkspaceUI(state, payload) {
        let plugin_id = payload.id
        let tagId = payload.tagId
        console.log(`[loadExternalPluginWorkspaceUI][loading plugin--->${plugin_id}]`)
        state.pluginMapper[plugin_id]["workspaceUiCallback"]($, tagId)
    }, */
    loadDashboardWidgetsFromExternalPlugin(state, payload) {
        let plugin_id = payload.id
        let tagId = payload.tagId
        let widgetId = payload.widgetId
        if(document.getElementById(widgetId)){
            if(!payload.forceUpdate)return false;
        }
        console.log(`[loadDashboardWidgetsFromExternalPlugin][loading plugin--->${plugin_id}]`)
        state.pluginMapper[plugin_id]["dashboardWidgetUICallback"]($, tagId, widgetId)
    },
    registerSystemSettingsMenu(state, payload) {
        if (typeof(payload) == undefined || !Object.keys(payload).includes("id") || payload.id.trim().length <= 0) {
            return
        }
        let menu = state.systemSettingsMenu.filter((oMenu) => oMenu.id == payload.id)
        if (menu.length == 0) {
            state.systemSettingsMenu.push(payload)
        }
        console.log('[Settings][systemSettingsMenu......]', state.systemSettingsMenu)
    },
    unSetSystemSettingsMenu(state) {
        state.systemSettingsMenu = []
    },
    updateSystemSettingsMenu(state, payload){
        if(payload && payload.id){
            for(let i = 0; i < state.systemSettingsMenu.length;i++){
                if(state.systemSettingsMenu[i].id == payload.id && payload.pluginName == state.systemSettingsMenu[i].pluginName){
                    state.systemSettingsMenu[i]['component'] = payload.component;
                }
            }
        }
    },
    registerPropertiesTopNav(state, payload) {
        if (typeof(payload) == undefined || !Object.keys(payload).includes("id") || payload.id.trim().length <= 0) {
            return
        }
        let menu = state.propertiesTopNav.filter((oMenu) => oMenu.id == payload.id)
        if (menu.length == 0) {
            state.propertiesTopNav.push(payload)
        }
    },
    unsetPropertiesTopNav(state) {
        state.propertiesTopNav = []
    },
    registerPropertiesMetadataPlugins(state, payload){
        if(!payload) return;
        if(payload && !Object.keys(payload).length) return;
        let button = state.metadataPluginExpandCollapseList.find((oMenu) => oMenu.id == payload.id)
        if(!button){
            state.metadataPluginExpandCollapseList.push(payload);
        }
    },
    updatePropertiesMetadataPlugins(state, payload){
        if(!payload) return;
        if(payload && !Object.keys(payload).length) return;
        let info = state.metadataPluginExpandCollapseList.find((oMenu) => oMenu.id == payload.id)
        if(info){
            Object.assign(info,payload.data);
        }
    },
    unsetPropertiesMetadataPlugins(state){
        state.metadataPluginExpandCollapseList = [];
    },
    registerMetadataDockPlugins(state, payload){
        if(!payload) return;
        if(payload && !Object.keys(payload).length) return;
        let button = state.metadataDockPluginsList.find((oMenu) => oMenu.id == payload.id)
        if(!button){
            state.metadataDockPluginsList.push(payload);
        }
    },
    updateMetadataDockPlugins(state, payload){
        if(!payload) return;
        if(payload && !Object.keys(payload).length) return;
        let info = state.metadataDockPluginsList.find((oMenu) => oMenu.id == payload.id)
        if(info){
            Object.assign(info,payload.data);
        }
    },
    registerPluginLicensePlugins(state, payload){  
        if(!payload) return;
        if(payload && !Object.keys(payload).length) return;
        let licenseInfo = state.licenseInfoDetails.find((oMenu) => oMenu.id == payload.id)
        if(!licenseInfo){
            state.licenseInfoDetails.push(payload);
      
        }
    },
    updatePluginsLicensePlugins(state, payload){
        if(!payload) return;
        if(payload && !Object.keys(payload).length) return;
        let info = state.licenseInfoDetails.find((oMenu) => oMenu.id == payload.id)
        if(info){
            Object.assign(info,payload.data);
        }
    },
    unsetMetadataDockPlugins(state){
        state.metadataDockPluginsList = [];
    },
    unsetOnlySelectedPropertiesTopMenu(state, payload){
        state.propertiesTopNav = state.propertiesTopNav.filter((oMenu) => oMenu.id != payload)
    },
    registerDialogForMediaBrowse(state, payload) {
        if (typeof(payload) == undefined || !Object.keys(payload).includes("id") || payload.id.trim().length <= 0) {
            return
        }
        let menu = state.dialogForMediaBrowse.filter((oMenu) => oMenu.id == payload.id)
        if (menu.length == 0) {
            state.dialogForMediaBrowse.push(payload)
        }
    },
    unsetDialogForMediaBrowse(state) {
        state.dialogForMediaBrowse = []
    },
    registerImportExportSettingsMenu(state, payload) {
        if (typeof(payload) == undefined || !Object.keys(payload).includes("id") || payload.id.trim().length <= 0) {
            return
        }
        let menu = state.importExportMenu.filter((oMenu) => oMenu.id == payload.id)
        if (menu.length == 0) {
            state.importExportMenu.push(payload)
        }
    },
    unSetImportExportSettingsMenu(state) {
        state.importExportMenu = []
    },
    registerShareExternalPlugins(state, payload) {
        if (typeof(payload) == undefined || !Object.keys(payload).includes("id") || payload.id.trim().length <= 0) {
            return
        }
        let menu = state.shareTopNavMenu.filter((oMenu) => oMenu.id == payload.id)
        if (menu.length == 0) {
            state.shareTopNavMenu.push(payload)
        }
    },
    registerGlobalButtonExternalPlugin(state, payload){
        if(!payload) return;
        if(payload && !Object.keys(payload).length) return;
        let button = state.externalGlobalNewButtonPlugins.find((oMenu) => oMenu.id == payload.id)
        if(!button){
            state.externalGlobalNewButtonPlugins.push(payload);
        }
    },
    registerCreateReviewButton(state,payload){
        if(!payload) return;
        if(payload && !Object.keys(payload).length) return;
        let button = state.createReviewButtons.find((oMenu) => oMenu.id == payload.id)
        if(!button){
            state.createReviewButtons.push(payload);
        }
    },
    registerReviewTags(state, payload){
        if(!payload) return;
        if(payload && !Object.keys(payload).length) return;
        let button = state.reviewTagsArr.find((oMenu) => oMenu.id == payload.id)
        if(!button){
            state.reviewTagsArr.push(payload);
        }
    },
    registerPropertiesTabPlugins(state, payload){
        if(!payload) return;
        if(payload && !Object.keys(payload).length) return;
        let data = state.propertiesTabsPlugins.find((oMenu) => oMenu.id == payload.id)
        if(!data){
            state.propertiesTabsPlugins.push(payload);
        }
    },
    registerDashboardWidgetsPlugins(state, payload){
        if(!payload) return;
        if(payload && !Object.keys(payload).length) return;
        let data = state.dashboardWidgetPlugin.find((oMenu) => oMenu.id == payload.id)
        if(!data){
            state.dashboardWidgetPlugin.push(payload);
        }
    },
    exposeDamComponents(state, payload){
        if(!payload) return;
        if(payload && !Object.keys(payload).length) return;
        Object.assign(state.damComponentOnDemand,payload);
    },
    registerPamBrowserFromPamPlugin(state, payload){
        console.log("payload.........",payload);
        if(!payload) return;
        if(payload && !Object.keys(payload).length) return;
        let data = state.pamBrowsePluginsList.find((oMenu) => oMenu.id == payload.id)
        if(!data){
            state.pamBrowsePluginsList.push(...payload);
        }

        console.log("pamBrowsePluginsList>>>>>", state.pamBrowsePluginsList)
    },
    registerSubclipPlugins(state, payload){
        if(!payload) return;
        if(payload && !Object.keys(payload).length) return;
        let button = state.subclipPluginsList.find((oMenu) => oMenu.id == payload.id)
        if(!button){
            state.subclipPluginsList.push(payload);
        }
    },
    registerCustomReportsPLugins(state, payload){
        if(!payload) return;
        if(payload && !Object.keys(payload).length) return;
        let dropdownValue = state.customReportsSelectionField.find((oMenu) => oMenu.id == payload.id)
        if(!dropdownValue){
            state.customReportsSelectionField.push(payload);
        }
    },
    updateCustomReportsPlugins(state, payload){
        if(!payload) return;
        if(payload && !Object.keys(payload).length) return;
        let info = state.customReportsSelectionField.find((oMenu) => oMenu.id == payload.id)
        if(info){
            Object.assign(info,payload.data);
        }
    },
    updateSubclipPlugins(state, payload){
        if(!payload) return;
        if(payload && !Object.keys(payload).length) return;
        let info = state.subclipPluginsList.find((oMenu) => oMenu.id == payload.id)
        if(info){
            Object.assign(info,payload.data);
        }
    },
    unsetSubclipPlugins(state){
        state.subclipPluginsList = [];
    },

    registerPluginRouterRoutesForLoading(state,payload){
       if(!state.registeredPluginRoutesForLoadingMapper[payload.routeName]){
           state.registeredPluginRoutesForLoadingMapper[payload.routeName] = payload;
       }
    },

    registerAllLinksBrowsePlugins(state, newBrowseList){
        console.log("[state.linksBrowsePluginsList]",state.linksBrowsePluginsList,"newBrowseList",newBrowseList);
        if(!newBrowseList) return;
        if(newBrowseList && !Object.keys(newBrowseList).length) return;
        if(Array.isArray(state.linksBrowsePluginsList) 
            && !state.linksBrowsePluginsList.length){
            if(Array.isArray(newBrowseList)){
                state.linksBrowsePluginsList = newBrowseList;
            }
        }else{
           let existingIds = state.linksBrowsePluginsList.map(e => e.id);
           console.log("[existingIds existingIds]",existingIds);
           for(let i = 0; i < newBrowseList.length; i++){
               if(existingIds.indexOf(newBrowseList[i].id) == -1){
                   state.linksBrowsePluginsList.push(newBrowseList[i]);
               }
           }
        }
    },

    //don't play Miniplayer or Asset doc in the background on top of registered list
    dontPlayOverlayScreensOverMiniplayerAssetDoc(state, screenName){
        if (!screenName) return;
        if (typeof screenName === 'object') return;

        if (!state.dontPlayMiniplayerInTheBackround_openedScreens.includes(screenName)) {
            state.dontPlayMiniplayerInTheBackround_openedScreens.push(screenName);
        }
    }
};